import BookHero from '../components/books/BookHero'
import book2Cover from '../assets/theinbetweencover.jpg';
import GetYourCopy from '../components/books/GetYourCopy';
import Testimonials from '../components/shared/Testimonials';
import AboutBook from '../components/books/AboutBook';
import WhatYouLearn from '../components/books/WhatYouLearn';
import AboutAuthor from '../components/shared/AboutAuthor';
import JoinMe from '../components/shared/JoinMe';
import BeforeFooter from '../components/layout/BeforeFooter';
import InbetweenConcept from '../components/books/InbetweenConcept';
/*import WhatsInThePackage from '../components/books/WhatsInThePackage'*/
import BookChat from '../components/books/BookChat';
import RelatedArticles from '../components/shared/RelatedArticles';
import FairWelcome from '../components/books/FairWelcome';
import BookVideo from '../components/books/BookVideo';

const book2 = {
  slug: 'inbetween',
  title: "The In-Between",
  subtitle: "A Journey to Balance and Healing",
  description: "Reflections on finding your balance in the In-Between, and healing along the journey.",
  availability: "Available now in paperback & digital formats.",
  covers: [book2Cover],
  previewLink: "/THEINBETWEEN_PREVIEW.pdf",
  orderText: "Order Now",
};

const theInBetweenContent = {
  bgColor: '#6e4f38',
  titleColor: '#fdf2e1',
  textColor: '#fdf2e1',
  learnTitle: "What You Learn in This Book",
  learnContent: [
    [
      'How swinging between extremes creates internal instability',
      'The hidden cost of perfection and over-discipline',
      'Why "too much good" can become harmful',
      'How trauma shapes your reactions more than you realize',
      'Why emotional awareness is the foundation of true balance',
    ],
    [
      'How to stop reacting and start responding consciously',
      'How to regulate your mind instead of fighting it',
      'The difference between control and conscious surrender',
      'How to reconnect with your body as a grounding anchor',
      'How to live steadily in the In-Between',
    ],
  ],
  learnMoreText: "and many more insights..."
};

const theInBetweenBook = {
  title: "The In-Between",
  cover: book2Cover,
  subtitle: "Understanding the Concept of the In-Between",
  intro: "Loubna explains the idea of the In-Between — the optimal point between extremes — and why finding balance matters in life. You'll see how this concept underpins the journey of healing across the four pillars: Trauma, Mind, Soul, and Body.",
  chapters: [
    {
      text: "Healing the Trauma",
      subtitle: "Healing the Trauma",
      description: "Loubna guides you through exploring your past, recognizing how unresolved trauma influences your present, and learning to live with your scars in peace rather than letting them control you."
    },
    {
      text: "Healing the Mind",
      subtitle: "Healing the Mind",
      description: "Take command of your inner dialogue, understand the ripple effect of your mental patterns, and cultivate clarity and resilience so that your mind supports your journey toward balance."
    },
    {
      text: "Healing the Soul",
      subtitle: "Healing the Soul",
      description: "Loubna invites you to explore the core of who you are beyond stories and scars, to nurture self-compassion, and to strengthen the part of you that observes, reflects, and thrives in the In-Between."
    },
    {
      text: "Healing the Body",
      subtitle: "Healing the Body",
      description: "Through mindful practices, you learn how the body holds, expresses, and releases what we experience internally, restoring vitality and embodying the balance you seek."
    },
  ],
};

const book2Testimonials = {
  type: 'book2',
  testimonials: [
    { quote: "This book gave me a push to start healing. Reading it felt like being guided by someone who truly cares about you, holding your hand every step of the way and reminding you that you're not alone. What I especially loved is how the book balances emotion and scientific. It describes the feelings and offers practical methods for dealing with what you're facing.", name: "Rokia Mouhoub" },
    { quote: "I truly loved this book! The concept of learning to have mercy on ourselves is so powerful and much needed. The author writes with a peaceful, healing style that makes you feel completely safe; it’s like having someone gently tapping you on the shoulder and whispering, \"It's okay, everything is going to be okay.\" I want to congratulate the author on all her hard work and thank her deeply for her purpose-driven mission to help others.", name: "Ines" },
  ],
};

function TheInBetween() {
  return (
    <div>
       <FairWelcome />
      <BookHero key={book2.slug} book={book2} />
      <GetYourCopy
        stores={{
          gumroad: "https://elbylit.gumroad.com/l/wafvso"
        }}
        localOnly={true}
        libraries={[
          { name: "Revolution Library", url: "https://www.instagram.com/librairie_de_la_revolution_/", style: "library-brown" },
          { name: "Crypto Library", url: "https://www.instagram.com/crypto_library19/", style: "library-terracotta" },
          { name: "Zahra Library", url: "https://www.instagram.com/librairie_zahra_23/", style: "library-plum" },
          { name: "Big Deal Bookstore", url: "https://bigdealbookstore.com/book/636b4c78-eadc-4278-80ce-753dba8020ac", style: "library-blue" }
        ]}
      />
      <BookVideo />
      <InbetweenConcept />
  
      <WhatYouLearn book={theInBetweenContent} />
      <AboutBook book={theInBetweenBook} />
      {/* <WhatsInThePackage /> */}
      <RelatedArticles bookSlug="inbetween" bgColor="#6e4f38" titleColor="#fdf2e1" textColor="#fdf2e1" />
      <Testimonials book={book2Testimonials} />
      <AboutAuthor />
      <JoinMe />
      <BeforeFooter />
      <BookChat />
    </div>
  );
}

export default TheInBetween;